const LiveNewsData = [
  {
    id: 1,
    image: "https://i.ibb.co/GTKQ9xR/download.png",
    text: "NDTV Live TV",
    link: "https://www.youtube.com/watch?v=WB-y7_ymPJ4",
    path: "ndtv",
  },
  {
    id: 2,
    image: "https://i.ibb.co/vP5gcDR/download-s.jpg",
    text: "SOMOY TV ",
    link: "https://www.youtube.com/watch?v=ORxX7AS4-Zg",
    path: "somoy",
  },

  {
    id: 3,
    image: "https://i.ibb.co/6nkGjhs/nbc.png",
    text: "NBC News ",
    link: "https://www.youtube.com/watch?v=zZO_vZM-6p8",
    path: "nbc",
  },
  {
    id: 4,
    image: "https://i.ibb.co/2ZZ7836/Gtv-live-cricket-logo.png",
    text: "G TV ",
    link: "https://youtu.be/vSHelsYpvkc",
    path: "gtv",
  },
  {
    id: 5,
    image: "https://i.ibb.co/NTzTCD5/download.png",
    text: "Al Jazeera English ",
    link: "https://youtu.be/F-POY4Q0QSI",
    path: "Jazeera",
  },

  {
    id: 6,
    image: "https://i.ibb.co/Lh6pMCb/Samaa-Live.jpg",
    text: "SAMAA TV",
    link: "https://youtu.be/VGm487f2R5k",
    path: "samaatv",
  },
  {
    id: 7,
    image: "https://i.ibb.co/r6NFL97/download-1.png",
    text: "ABP Ananda",
    link: "https://youtu.be/PKwLsAu-z10",
    path: "abp ananda",
  },

  {
    id: 8,
    image: "https://i.ibb.co/JFTVKWh/WION-logo-1200.webp",
    text: "WION",
    link: "https://youtu.be/KyUT37gNm5w",
    path: "wion",
  },
  {
    id: 9,
    image: "https://i.ibb.co/VgvggCh/tr-trt-world-2715.jpg",
    text: "TRT World",
    link: "https://youtu.be/5mL-OkdM7Tc",
    path: "trt world",
  },

  {
    id: 10,
    image: "https://i.ibb.co/nwWRcjM/maxresdefault.jpg",
    text: "Tnews Telugu Live ",
    link: "https://youtu.be/WpVr0MtuOYs",
    path: "tnews telugu",
  },
  {
    id: 11,
    image: "https://i.ibb.co/KhfP7T0/live-tv-og.jpg",
    text: "IndiaTV LIVE ",
    link: "https://youtu.be/Xmm3Kr5P1Uw",
    path: "indiatv",
  },
  {
    id: 12,
    image: "https://i.ibb.co/w7qD4Mj/Main-Image-SN.webp",
    text: "Sky News live ",
    link: "https://youtu.be/9Auq9mYxFEE",
    path: "sky news",
  },
  {
    id: 13,
    image: "https://i.ibb.co/FK3C9K5/1200px-Deutsche-Welle-symbol-2012-svg.png",
    text: "DW News",
    link: "https://youtu.be/GE_SfNVNyqk",
    path: "dw news",
  },
  {
    id: 14,
    image: "https://i.ibb.co/mGSSSH1/bd-atn-news-5643.jpg",
    text: "ATN News",
    link: "https://youtu.be/XZpyQTwsSQA",
    path: "atn news",
  },
  {
    id: 15,
    image: "https://i.ibb.co/qnk9fmX/qt5ws1zwkxp9lfvheeis.webp",
    text: "CHANNEL24 LIVE ",
    link: "https://youtu.be/wdcWMnqgatA",
    path: "Channel24",
  },
  {
    id: 16,
    image: "https://i.ibb.co/mRZvrrf/DBC-News-logo.png",
    text: "DBC NEWS",
    link: "https://www.youtube.com/watch?v=dDQFjUF4_9c",
    path: "dbc",
  },
  {
    id: 17,
    image: "https://i.ibb.co/9Zstmb9/download-1.png",
    text: "CNN News",
    link: "https://www.youtube.com/watch?v=rpWMg_axGtg",
    path: "cnn",
  },

  {
    id: 18,
    image: "https://i.ibb.co/42Rjv6B/abc.png",
    text: "ABC News",
    link: "https://www.youtube.com/watch?v=w_Ma8oQLmSM",
    path: "abc",
  },
];

export default LiveNewsData;
